import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import SearchInput from '../../../components/SearchInput';
import useAuth from '../../../context/AuthContext';
import AdminExportUsers from '../../../components/AdminExportUsers';
import SideActionBoard from '../../../components/SideActionBoard';
import Filters from '../../../components/SideBarFilters';
import { adminAPI } from '../../../api';

const TabSelection = ({ 
  setCurrentTab,
  currentTab,
  searchQuery,
  setSearchQuery,
  onClearSearch,
  filter,
  setFilter,
  onClearFilters,
  setOpenSideActionBoard,
  hasNonUsers,
  handleSelectAllActiveUsers,
  checkedActiveUsers,
  checkedAllActiveUsers,
  totalUsers
}) => {
  const tabs = ['Users and Invites'];
  const showFilters = { email: true, date: false, cohort: true, user_confirmation: true, user_expiration: true, alex_expiration: true, alex_access_type: true, user_access_type: true, invited_by: true };
  const { userData, isEmployee, isTenant } = useAuth();
  const isAdmin = userData?.roles?.includes('admin');
  const hasAccess = isAdmin || isEmployee;
  const [toggleFilter, setToggleFilter] = useState(false);

  const { data: invitationData } = useQuery(
    'invitationData',
    adminAPI.getInvitationData
  );

  const onSelectFilters = useCallback(
    (selectedFilters) => setFilter(selectedFilters),
    [filter]
  );

  return (
    <>
      <div className="flex border-b-2 border-gray items-center justify-between mb-6 gap-6 flex-no-wrap">
        <div className="flex items-center gap-6">
          {hasAccess && (
            <ul className="flex items-center p-0">
              {tabs.map((val, tabIndex) => (
                <div
                  key={`tab-${tabIndex}`}
                  className={`${
                    currentTab === val &&
                    searchQuery === '' &&
                    'border-b-4 border-purple whitespace-no-wrap'
                  }`}
                >
                  <button
                    onClick={() => setCurrentTab(val)}
                    type="button"
                    className={`px-4 py-5 ${
                      currentTab === val &&
                      searchQuery === '' &&
                      'font-semibold'
                    }`}
                  >
                    {val}
                  </button>
                </div>
              ))}
            </ul>
          )}
          {hasAccess && (
            <SearchInput
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              onClearSearch={onClearSearch}
              active={searchQuery !== ''}
            />
          )}
          <p
            className="underline cursor-pointer"
            onClick={() => setToggleFilter(true)}
          >
            {`Filters${
              Object.keys(filter).length > 0
                ? ' (' + (parseInt(Object.keys(filter).length) + (Object.keys(filter['date'] || {}).length > 0 ? Object.keys(filter['date'] || {}).length - 1 : 0)) + ')'
                : ''
            }`}
          </p>
        </div>
        <div className="flex">
          {!isTenant && (
            <button
              type="button"
              className="p-4 font-semibold bg-purple-100 hover:bg-purple-200 rounded-lg whitespace-no-wrap"
              onClick={() =>
                setOpenSideActionBoard({
                  type: 'Invite Users',
                  action: 'edit',
                })
              }
            >
              Invite Users
            </button>
          )}
          {hasAccess && (
            <AdminExportUsers
              filters={filter}
              searchQuery={searchQuery}
              hasNonUsers={hasNonUsers}
              checkedActiveUsers={checkedActiveUsers}
              checkedAllActiveUsers={checkedAllActiveUsers}
              totalUsers={totalUsers}
            />
          )}
        </div>
      </div>
      {toggleFilter && (
        <SideActionBoard setOpenSideActionBoard={() => setToggleFilter(false)}>
          <Filters 
            onSelectFilters={onSelectFilters} 
            selectedFilters={filter}
            onClearFilters={onClearFilters}
            alexAccessTypes={invitationData?.alex_access_type_options || []}
            hubspotAccessTypes={invitationData?.hubspot_options || []}
            cohorts={invitationData?.cohort_options || []}
            handleSelectAllUsers={(selectAll) => {
              handleSelectAllActiveUsers(selectAll);
            }}
            showFilters={showFilters}
          />
        </SideActionBoard>
      )}
    </>
  );
};

export default TabSelection;
